import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { PlusIcon, FilterIcon, DownloadIcon, EyeIcon, EditIcon, TrashIcon, MapPinIcon, QrCodeIcon, TagIcon, UploadIcon, SearchIcon, InfoIcon, ArrowLeftIcon, CheckIcon, XIcon, BuildingIcon } from 'lucide-react';
import Card from '../../components/ui/Card';
import Table from '../../components/ui/Table';
import StatusBadge from '../../components/ui/StatusBadge';
import Modal from '../../components/ui/Modal';
import ExportMenu from '../../components/ui/ExportMenu';
// Mock chain merchant data
const chainMerchantsData = [{
  id: 'CM001',
  name: 'CityMart Stores',
  businessType: 'Retail',
  taxId: 'TX-1234567',
  status: 'active',
  superMerchant: 'Global Retail Group',
  superMerchantId: 'SM001',
  storeCount: 24,
  transactionVolume: 520000,
  lastActivity: '2023-07-15T09:30:00Z',
  contactPerson: 'Alice Johnson',
  email: 'alice@citymart.com',
  phone: '+1 (555) 123-4567'
}, {
  id: 'CM002',
  name: 'HomeGoods Plus',
  businessType: 'Home Improvement',
  taxId: 'TX-7654321',
  status: 'active',
  superMerchant: 'Global Retail Group',
  superMerchantId: 'SM001',
  storeCount: 15,
  transactionVolume: 480000,
  lastActivity: '2023-07-14T15:45:00Z',
  contactPerson: 'Bob Smith',
  email: 'bob@homegoodsplus.com',
  phone: '+1 (555) 987-6543'
}, {
  id: 'CM003',
  name: 'Quick Burger Chain',
  businessType: 'Food & Beverage',
  taxId: 'TX-9876543',
  status: 'active',
  superMerchant: 'Fast Food Alliance',
  superMerchantId: 'SM002',
  storeCount: 32,
  transactionVolume: 620000,
  lastActivity: '2023-07-16T12:30:00Z',
  contactPerson: 'Carol Davis',
  email: 'carol@quickburger.com',
  phone: '+1 (555) 456-7890'
}, {
  id: 'CM004',
  name: 'Fresh Salad Bars',
  businessType: 'Food & Beverage',
  taxId: 'TX-5432198',
  status: 'active',
  superMerchant: 'Fast Food Alliance',
  superMerchantId: 'SM002',
  storeCount: 18,
  transactionVolume: 240000,
  lastActivity: '2023-07-15T11:45:00Z',
  contactPerson: 'David Wilson',
  email: 'david@freshsalad.com',
  phone: '+1 (555) 234-5678'
}, {
  id: 'CM005',
  name: 'Gadget World',
  businessType: 'Technology',
  taxId: 'TX-8765432',
  status: 'inactive',
  superMerchant: 'Tech Distribution Network',
  superMerchantId: 'SM003',
  storeCount: 8,
  transactionVolume: 320000,
  lastActivity: '2023-06-28T14:30:00Z',
  contactPerson: 'Eva Brown',
  email: 'eva@gadgetworld.com',
  phone: '+1 (555) 876-5432'
}];
// Mock store data for each chain merchant
const storesData = {
  CM001: [{
    id: 'ST001',
    name: 'CityMart Downtown',
    address: '123 Main St, Downtown, NY 10001',
    status: 'active',
    transactionVolume: 85000,
    terminalCount: 4,
    lastActivity: '2023-07-15T09:30:00Z'
  }, {
    id: 'ST002',
    name: 'CityMart Uptown',
    address: '456 Park Ave, Uptown, NY 10002',
    status: 'active',
    transactionVolume: 72000,
    terminalCount: 3,
    lastActivity: '2023-07-14T15:45:00Z'
  }, {
    id: 'ST003',
    name: 'CityMart Midtown',
    address: '789 Broadway, Midtown, NY 10003',
    status: 'inactive',
    transactionVolume: 45000,
    terminalCount: 2,
    lastActivity: '2023-07-10T11:20:00Z'
  }],
  CM002: [{
    id: 'ST004',
    name: 'HomeGoods Plus North',
    address: '101 North Blvd, North Side, NY 10004',
    status: 'active',
    transactionVolume: 95000,
    terminalCount: 5,
    lastActivity: '2023-07-15T10:15:00Z'
  }, {
    id: 'ST005',
    name: 'HomeGoods Plus South',
    address: '202 South St, South Side, NY 10005',
    status: 'active',
    transactionVolume: 88000,
    terminalCount: 4,
    lastActivity: '2023-07-14T16:30:00Z'
  }],
  CM003: [{
    id: 'ST006',
    name: 'Quick Burger - Times Square',
    address: '123 Times Square, NY 10006',
    status: 'active',
    transactionVolume: 65000,
    terminalCount: 3,
    lastActivity: '2023-07-16T12:30:00Z'
  }, {
    id: 'ST007',
    name: 'Quick Burger - Central Park',
    address: '456 Central Park West, NY 10007',
    status: 'active',
    transactionVolume: 58000,
    terminalCount: 2,
    lastActivity: '2023-07-15T14:20:00Z'
  }, {
    id: 'ST008',
    name: 'Quick Burger - Brooklyn',
    address: '789 Brooklyn Ave, Brooklyn, NY 11201',
    status: 'pending',
    transactionVolume: 0,
    terminalCount: 2,
    lastActivity: '2023-07-14T09:45:00Z'
  }]
};
// Mock super merchants for dropdown
const superMerchantsOptions = [{
  id: 'SM001',
  name: 'Global Retail Group'
}, {
  id: 'SM002',
  name: 'Fast Food Alliance'
}, {
  id: 'SM003',
  name: 'Tech Distribution Network'
}, {
  id: 'SM004',
  name: 'Hospitality Group International'
}, {
  id: 'SM005',
  name: 'Urban Transport Consortium'
}];
interface ChainMerchant {
  id: string;
  name: string;
  businessType: string;
  taxId: string;
  status: string;
  superMerchant: string;
  superMerchantId: string;
  storeCount: number;
  transactionVolume: number;
  lastActivity: string;
  contactPerson: string;
  email: string;
  phone: string;
}
interface Store {
  id: string;
  name: string;
  address: string;
  status: string;
  transactionVolume: number;
  terminalCount: number;
  lastActivity: string;
}
const ChainMerchantSetup: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const selectedChainId = queryParams.get('id');
  const [chainMerchants, setChainMerchants] = useState<ChainMerchant[]>(chainMerchantsData);
  const [showFilters, setShowFilters] = useState(false);
  const [selectedChainMerchant, setSelectedChainMerchant] = useState<ChainMerchant | null>(selectedChainId ? chainMerchantsData.find(m => m.id === selectedChainId) || null : null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [showAddEditModal, setShowAddEditModal] = useState(false);
  const [showAddStoreModal, setShowAddStoreModal] = useState(false);
  const [showBulkUploadModal, setShowBulkUploadModal] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [viewingStores, setViewingStores] = useState(!!selectedChainId);
  // Form state for add/edit modal
  const [formData, setFormData] = useState<Partial<ChainMerchant>>({
    name: '',
    businessType: '',
    taxId: '',
    status: 'active',
    superMerchantId: '',
    contactPerson: '',
    email: '',
    phone: ''
  });
  // Form state for add store modal
  const [storeFormData, setStoreFormData] = useState<Partial<Store>>({
    name: '',
    address: '',
    status: 'active'
  });
  const handleAddChainMerchant = () => {
    setIsEditing(false);
    setFormData({
      name: '',
      businessType: '',
      taxId: '',
      status: 'active',
      superMerchantId: '',
      contactPerson: '',
      email: '',
      phone: ''
    });
    setShowAddEditModal(true);
  };
  const handleEditChainMerchant = (merchant: ChainMerchant) => {
    setIsEditing(true);
    setFormData({
      ...merchant
    });
    setShowAddEditModal(true);
  };
  const handleDeleteChainMerchant = (merchant: ChainMerchant) => {
    setSelectedChainMerchant(merchant);
    setShowDeleteModal(true);
  };
  const handleViewChainMerchant = (merchant: ChainMerchant) => {
    setSelectedChainMerchant(merchant);
    setShowViewModal(true);
  };
  const handleViewStores = (merchant: ChainMerchant) => {
    setSelectedChainMerchant(merchant);
    setViewingStores(true);
    navigate(`/chain-merchants?id=${merchant.id}`);
  };
  const handleBackToChainList = () => {
    setViewingStores(false);
    setSelectedChainMerchant(null);
    navigate('/chain-merchants');
  };
  const handleAddStore = () => {
    setStoreFormData({
      name: '',
      address: '',
      status: 'active'
    });
    setShowAddStoreModal(true);
  };
  const handleBulkUpload = () => {
    setShowBulkUploadModal(true);
  };
  const confirmDelete = () => {
    if (selectedChainMerchant) {
      setChainMerchants(chainMerchants.filter(m => m.id !== selectedChainMerchant.id));
      setShowDeleteModal(false);
      setSelectedChainMerchant(null);
      if (viewingStores) {
        setViewingStores(false);
        navigate('/chain-merchants');
      }
    }
  };
  const handleFormChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleStoreFormChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const {
      name,
      value
    } = e.target;
    setStoreFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleSubmitForm = () => {
    if (isEditing && selectedChainMerchant) {
      // Update existing chain merchant
      const updatedMerchants = chainMerchants.map(m => m.id === selectedChainMerchant.id ? {
        ...m,
        ...formData,
        storeCount: m.storeCount,
        transactionVolume: m.transactionVolume,
        lastActivity: m.lastActivity,
        superMerchant: superMerchantsOptions.find(sm => sm.id === formData.superMerchantId)?.name || m.superMerchant
      } : m);
      setChainMerchants(updatedMerchants);
      if (viewingStores) {
        setSelectedChainMerchant(updatedMerchants.find(m => m.id === selectedChainMerchant.id) || null);
      }
    } else {
      // Add new chain merchant
      const superMerchantInfo = superMerchantsOptions.find(sm => sm.id === formData.superMerchantId);
      const newChainMerchant: ChainMerchant = {
        id: `CM${String(chainMerchants.length + 1).padStart(3, '0')}`,
        name: formData.name || '',
        businessType: formData.businessType || '',
        taxId: formData.taxId || '',
        status: formData.status || 'active',
        superMerchantId: formData.superMerchantId || '',
        superMerchant: superMerchantInfo?.name || 'Unassigned',
        storeCount: 0,
        transactionVolume: 0,
        lastActivity: new Date().toISOString(),
        contactPerson: formData.contactPerson || '',
        email: formData.email || '',
        phone: formData.phone || ''
      };
      setChainMerchants([...chainMerchants, newChainMerchant]);
    }
    setShowAddEditModal(false);
  };
  const handleSubmitStoreForm = () => {
    if (selectedChainMerchant) {
      // In a real app, you would update the store data in the backend
      console.log(`Adding store to ${selectedChainMerchant.name}:`, storeFormData);
      const updatedMerchants = chainMerchants.map(m => m.id === selectedChainMerchant.id ? {
        ...m,
        storeCount: m.storeCount + 1,
        lastActivity: new Date().toISOString()
      } : m);
      setChainMerchants(updatedMerchants);
      setSelectedChainMerchant(updatedMerchants.find(m => m.id === selectedChainMerchant.id) || null);
    }
    setShowAddStoreModal(false);
  };
  const handleExport = (format: 'csv' | 'xlsx' | 'pdf') => {
    console.log(`Exporting ${viewingStores ? 'stores' : 'chain merchants'} as ${format}`);
  };
  const formatDateTime = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };
  const formatCurrency = (amount: number) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(amount);
  };
  const getStatusBadge = (status: string) => {
    switch (status) {
      case 'active':
        return <StatusBadge status="success" text="Active" data-id="element-662" />;
      case 'inactive':
        return <StatusBadge status="danger" text="Inactive" data-id="element-663" />;
      case 'pending':
        return <StatusBadge status="warning" text="Pending" data-id="element-664" />;
      default:
        return <StatusBadge status="default" text={status} data-id="element-665" />;
    }
  };
  const chainMerchantColumns = [{
    header: 'Chain Merchant',
    accessor: (merchant: ChainMerchant) => <div data-id="element-666">
          <div className="font-medium" data-id="element-667">{merchant.name}</div>
          <div className="text-xs text-gray-500 dark:text-gray-400" data-id="element-668">
            {merchant.id}
          </div>
        </div>,
    sortable: false
  }, {
    header: 'Business Type',
    accessor: 'businessType',
    sortable: true
  }, {
    header: 'Super Merchant',
    accessor: 'superMerchant',
    sortable: true
  }, {
    header: 'Status',
    accessor: (merchant: ChainMerchant) => getStatusBadge(merchant.status),
    sortable: false
  }, {
    header: 'Store Count',
    accessor: 'storeCount',
    sortable: true
  }, {
    header: 'Transaction Volume',
    accessor: (merchant: ChainMerchant) => formatCurrency(merchant.transactionVolume),
    sortable: true
  }];
  const storeColumns = [{
    header: 'Store',
    accessor: (store: Store) => <div data-id="element-669">
          <div className="font-medium" data-id="element-670">{store.name}</div>
          <div className="text-xs text-gray-500 dark:text-gray-400" data-id="element-671">
            {store.id}
          </div>
        </div>,
    sortable: false
  }, {
    header: 'Address',
    accessor: 'address',
    sortable: true
  }, {
    header: 'Status',
    accessor: (store: Store) => getStatusBadge(store.status),
    sortable: false
  }, {
    header: 'Terminals',
    accessor: 'terminalCount',
    sortable: true
  }, {
    header: 'Transaction Volume',
    accessor: (store: Store) => formatCurrency(store.transactionVolume),
    sortable: true
  }, {
    header: 'Last Activity',
    accessor: (store: Store) => formatDateTime(store.lastActivity),
    sortable: true
  }];
  const filteredChainMerchants = chainMerchants.filter(merchant => merchant.name.toLowerCase().includes(searchQuery.toLowerCase()) || merchant.id.toLowerCase().includes(searchQuery.toLowerCase()) || merchant.businessType.toLowerCase().includes(searchQuery.toLowerCase()) || merchant.superMerchant.toLowerCase().includes(searchQuery.toLowerCase()));
  const currentStores = selectedChainMerchant ? storesData[selectedChainMerchant.id] || [] : [];
  return <div className="space-y-6" data-id="element-672">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between" data-id="element-673">
        {viewingStores && selectedChainMerchant ? <>
            <div data-id="element-674">
              <button onClick={handleBackToChainList} className="inline-flex items-center text-sm text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300" data-id="element-675">
                <ArrowLeftIcon className="h-4 w-4 mr-1" data-id="element-676" />
                Back to Chain Merchants
              </button>
              <h1 className="text-2xl font-bold text-gray-900 dark:text-white mt-1" data-id="element-677">
                {selectedChainMerchant.name} Stores
              </h1>
              <p className="text-sm text-gray-500 dark:text-gray-400 mt-1" data-id="element-678">
                Manage stores for {selectedChainMerchant.name} (
                {selectedChainMerchant.id})
              </p>
            </div>
            <div className="mt-3 sm:mt-0 flex flex-wrap gap-2" data-id="element-679">
              <button onClick={handleBulkUpload} className="inline-flex items-center px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm text-sm font-medium text-gray-700 dark:text-gray-200 bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700" data-id="element-680">
                <UploadIcon className="h-4 w-4 mr-2" data-id="element-681" />
                Bulk Upload
              </button>
              <ExportMenu onExport={handleExport} data-id="element-682" />
              <button onClick={handleAddStore} className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700" data-id="element-683">
                <PlusIcon className="h-4 w-4 mr-2" data-id="element-684" />
                Add Store
              </button>
            </div>
          </> : <>
            <h1 className="text-2xl font-bold text-gray-900 dark:text-white" data-id="element-685">
              Chain Merchant Setup
            </h1>
            <div className="mt-3 sm:mt-0 flex flex-wrap gap-2" data-id="element-686">
              <button onClick={() => setShowFilters(!showFilters)} className="inline-flex items-center px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm text-sm font-medium text-gray-700 dark:text-gray-200 bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700" data-id="element-687">
                <FilterIcon className="h-4 w-4 mr-2" data-id="element-688" />
                Filters
              </button>
              <ExportMenu onExport={handleExport} data-id="element-689" />
              <button onClick={handleAddChainMerchant} className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700" data-id="element-690">
                <PlusIcon className="h-4 w-4 mr-2" data-id="element-691" />
                Add Chain Merchant
              </button>
            </div>
          </>}
      </div>

      {/* Dashboard Cards - Only show when viewing stores */}
      {viewingStores && selectedChainMerchant && <div className="grid grid-cols-1 md:grid-cols-4 gap-4" data-id="element-692">
          <Card className="bg-blue-50 dark:bg-blue-900/20 border-blue-100 dark:border-blue-800" data-id="element-693">
            <div className="flex items-center" data-id="element-694">
              <div className="p-3 rounded-full bg-blue-100 dark:bg-blue-800 mr-4" data-id="element-695">
                <MapPinIcon className="h-6 w-6 text-blue-600 dark:text-blue-400" data-id="element-696" />
              </div>
              <div data-id="element-697">
                <p className="text-sm font-medium text-blue-600 dark:text-blue-400" data-id="element-698">
                  Total Stores
                </p>
                <p className="text-2xl font-semibold text-gray-900 dark:text-white" data-id="element-699">
                  {selectedChainMerchant.storeCount}
                </p>
              </div>
            </div>
          </Card>
          <Card className="bg-green-50 dark:bg-green-900/20 border-green-100 dark:border-green-800" data-id="element-700">
            <div className="flex items-center" data-id="element-701">
              <div className="p-3 rounded-full bg-green-100 dark:bg-green-800 mr-4" data-id="element-702">
                <TagIcon className="h-6 w-6 text-green-600 dark:text-green-400" data-id="element-703" />
              </div>
              <div data-id="element-704">
                <p className="text-sm font-medium text-green-600 dark:text-green-400" data-id="element-705">
                  Active Stores
                </p>
                <p className="text-2xl font-semibold text-gray-900 dark:text-white" data-id="element-706">
                  {currentStores.filter(store => store.status === 'active').length}
                </p>
              </div>
            </div>
          </Card>
          <Card className="bg-purple-50 dark:bg-purple-900/20 border-purple-100 dark:border-purple-800" data-id="element-707">
            <div className="flex items-center" data-id="element-708">
              <div className="p-3 rounded-full bg-purple-100 dark:bg-purple-800 mr-4" data-id="element-709">
                <QrCodeIcon className="h-6 w-6 text-purple-600 dark:text-purple-400" data-id="element-710" />
              </div>
              <div data-id="element-711">
                <p className="text-sm font-medium text-purple-600 dark:text-purple-400" data-id="element-712">
                  Total Terminals
                </p>
                <p className="text-2xl font-semibold text-gray-900 dark:text-white" data-id="element-713">
                  {currentStores.reduce((sum, store) => sum + store.terminalCount, 0)}
                </p>
              </div>
            </div>
          </Card>
          <Card className="bg-amber-50 dark:bg-amber-900/20 border-amber-100 dark:border-amber-800" data-id="element-714">
            <div className="flex items-center" data-id="element-715">
              <div className="p-3 rounded-full bg-amber-100 dark:bg-amber-800 mr-4" data-id="element-716">
                <DownloadIcon className="h-6 w-6 text-amber-600 dark:text-amber-400" data-id="element-717" />
              </div>
              <div data-id="element-718">
                <p className="text-sm font-medium text-amber-600 dark:text-amber-400" data-id="element-719">
                  Transaction Volume
                </p>
                <p className="text-2xl font-semibold text-gray-900 dark:text-white" data-id="element-720">
                  {formatCurrency(currentStores.reduce((sum, store) => sum + store.transactionVolume, 0))}
                </p>
              </div>
            </div>
          </Card>
        </div>}

      {/* Search and Filters */}
      <div className="flex flex-col md:flex-row gap-4" data-id="element-721">
        <div className="relative flex-grow" data-id="element-722">
          <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none" data-id="element-723">
            <SearchIcon className="w-5 h-5 text-gray-500 dark:text-gray-400" data-id="element-724" />
          </div>
          <input type="text" className="bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 text-gray-900 dark:text-white text-sm rounded-md block w-full pl-10 p-2.5" placeholder={viewingStores ? 'Search stores...' : 'Search by name, ID, or business type...'} value={searchQuery} onChange={e => setSearchQuery(e.target.value)} data-id="element-725" />
        </div>
      </div>

      {showFilters && !viewingStores && <Card data-id="element-726">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-727">
            <div data-id="element-728">
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" data-id="element-729">
                Status
              </label>
              <select className="w-full rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 py-2 px-3 text-sm" data-id="element-730">
                <option value="" data-id="element-731">All Statuses</option>
                <option value="active" data-id="element-732">Active</option>
                <option value="inactive" data-id="element-733">Inactive</option>
                <option value="pending" data-id="element-734">Pending</option>
              </select>
            </div>
            <div data-id="element-735">
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" data-id="element-736">
                Business Type
              </label>
              <select className="w-full rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 py-2 px-3 text-sm" data-id="element-737">
                <option value="" data-id="element-738">All Types</option>
                <option value="Retail" data-id="element-739">Retail</option>
                <option value="Food & Beverage" data-id="element-740">Food & Beverage</option>
                <option value="Technology" data-id="element-741">Technology</option>
                <option value="Home Improvement" data-id="element-742">Home Improvement</option>
              </select>
            </div>
            <div data-id="element-743">
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" data-id="element-744">
                Super Merchant
              </label>
              <select className="w-full rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 py-2 px-3 text-sm" data-id="element-745">
                <option value="" data-id="element-746">All Super Merchants</option>
                {superMerchantsOptions.map(sm => <option key={sm.id} value={sm.id} data-id="element-747">
                    {sm.name}
                  </option>)}
              </select>
            </div>
          </div>
          <div className="mt-4 flex justify-end space-x-3" data-id="element-748">
            <button className="px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md text-sm font-medium text-gray-700 dark:text-gray-200 bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700" data-id="element-749">
              Reset
            </button>
            <button className="px-4 py-2 border border-transparent rounded-md text-sm font-medium text-white bg-blue-600 hover:bg-blue-700" data-id="element-750">
              Apply Filters
            </button>
          </div>
        </Card>}

      <Card data-id="element-751">
        {viewingStores && selectedChainMerchant ? <Table columns={storeColumns} data={currentStores} keyField="id" actions={store => <div className="flex justify-end space-x-2" data-id="element-753">
                <button className="p-1 rounded-full text-gray-500 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700" title="View" data-id="element-754">
                  <EyeIcon className="h-5 w-5" data-id="element-755" />
                </button>
                <button className="p-1 rounded-full text-blue-600 dark:text-blue-400 hover:bg-blue-100 dark:hover:bg-blue-900/30" title="Edit" data-id="element-756">
                  <EditIcon className="h-5 w-5" data-id="element-757" />
                </button>
                <button className="p-1 rounded-full text-red-600 dark:text-red-400 hover:bg-red-100 dark:hover:bg-red-900/30" title="Delete" data-id="element-758">
                  <TrashIcon className="h-5 w-5" data-id="element-759" />
                </button>
              </div>} data-id="element-752" /> : <Table columns={chainMerchantColumns} data={filteredChainMerchants} keyField="id" actions={merchant => <div className="flex justify-end space-x-2" data-id="element-761">
                <button onClick={() => handleViewChainMerchant(merchant)} className="p-1 rounded-full text-gray-500 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700" title="View" data-id="element-762">
                  <EyeIcon className="h-5 w-5" data-id="element-763" />
                </button>
                <button onClick={() => handleViewStores(merchant)} className="p-1 rounded-full text-purple-600 dark:text-purple-400 hover:bg-purple-100 dark:hover:bg-purple-900/30" title="View Stores" data-id="element-764">
                  <MapPinIcon className="h-5 w-5" data-id="element-765" />
                </button>
                <button onClick={() => handleEditChainMerchant(merchant)} className="p-1 rounded-full text-blue-600 dark:text-blue-400 hover:bg-blue-100 dark:hover:bg-blue-900/30" title="Edit" data-id="element-766">
                  <EditIcon className="h-5 w-5" data-id="element-767" />
                </button>
                <button onClick={() => handleDeleteChainMerchant(merchant)} className="p-1 rounded-full text-red-600 dark:text-red-400 hover:bg-red-100 dark:hover:bg-red-900/30" title="Delete" data-id="element-768">
                  <TrashIcon className="h-5 w-5" data-id="element-769" />
                </button>
              </div>} data-id="element-760" />}
      </Card>

      {/* View Chain Merchant Modal */}
      <Modal isOpen={showViewModal} onClose={() => setShowViewModal(false)} title="Chain Merchant Details" size="lg" data-id="element-770">
        {selectedChainMerchant && <div className="space-y-6" data-id="element-771">
            <div className="flex items-center" data-id="element-772">
              <div className="p-3 rounded-full bg-blue-100 dark:bg-blue-800 mr-4" data-id="element-773">
                <BuildingIcon className="h-6 w-6 text-blue-600 dark:text-blue-400" data-id="element-774" />
              </div>
              <div data-id="element-775">
                <h3 className="text-lg font-medium" data-id="element-776">
                  {selectedChainMerchant.name}
                </h3>
                <div className="flex items-center mt-1" data-id="element-777">
                  {getStatusBadge(selectedChainMerchant.status)}
                  <span className="mx-2 text-gray-500 dark:text-gray-400" data-id="element-778">
                    •
                  </span>
                  <span className="text-sm text-gray-500 dark:text-gray-400" data-id="element-779">
                    {selectedChainMerchant.businessType}
                  </span>
                </div>
              </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-780">
              <div data-id="element-781">
                <h4 className="text-sm font-medium text-gray-500 dark:text-gray-400 mb-3" data-id="element-782">
                  Chain Merchant Information
                </h4>
                <div className="bg-gray-50 dark:bg-gray-800 rounded-lg p-4 space-y-2" data-id="element-783">
                  <div className="flex justify-between" data-id="element-784">
                    <span className="text-sm font-medium" data-id="element-785">ID:</span>
                    <span className="text-sm" data-id="element-786">{selectedChainMerchant.id}</span>
                  </div>
                  <div className="flex justify-between" data-id="element-787">
                    <span className="text-sm font-medium" data-id="element-788">Tax ID:</span>
                    <span className="text-sm" data-id="element-789">
                      {selectedChainMerchant.taxId}
                    </span>
                  </div>
                  <div className="flex justify-between" data-id="element-790">
                    <span className="text-sm font-medium" data-id="element-791">Super Merchant:</span>
                    <span className="text-sm" data-id="element-792">
                      {selectedChainMerchant.superMerchant}
                    </span>
                  </div>
                  <div className="flex justify-between" data-id="element-793">
                    <span className="text-sm font-medium" data-id="element-794">Store Count:</span>
                    <span className="text-sm" data-id="element-795">
                      {selectedChainMerchant.storeCount}
                    </span>
                  </div>
                  <div className="flex justify-between" data-id="element-796">
                    <span className="text-sm font-medium" data-id="element-797">
                      Transaction Volume:
                    </span>
                    <span className="text-sm" data-id="element-798">
                      {formatCurrency(selectedChainMerchant.transactionVolume)}
                    </span>
                  </div>
                  <div className="flex justify-between" data-id="element-799">
                    <span className="text-sm font-medium" data-id="element-800">Last Activity:</span>
                    <span className="text-sm" data-id="element-801">
                      {formatDateTime(selectedChainMerchant.lastActivity)}
                    </span>
                  </div>
                </div>
              </div>
              <div data-id="element-802">
                <h4 className="text-sm font-medium text-gray-500 dark:text-gray-400 mb-3" data-id="element-803">
                  Contact Information
                </h4>
                <div className="bg-gray-50 dark:bg-gray-800 rounded-lg p-4 space-y-2" data-id="element-804">
                  <div className="flex justify-between" data-id="element-805">
                    <span className="text-sm font-medium" data-id="element-806">Contact Person:</span>
                    <span className="text-sm" data-id="element-807">
                      {selectedChainMerchant.contactPerson}
                    </span>
                  </div>
                  <div className="flex justify-between" data-id="element-808">
                    <span className="text-sm font-medium" data-id="element-809">Email:</span>
                    <span className="text-sm" data-id="element-810">
                      {selectedChainMerchant.email}
                    </span>
                  </div>
                  <div className="flex justify-between" data-id="element-811">
                    <span className="text-sm font-medium" data-id="element-812">Phone:</span>
                    <span className="text-sm" data-id="element-813">
                      {selectedChainMerchant.phone}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="border-t border-gray-200 dark:border-gray-700 pt-4 mt-4" data-id="element-814">
              <h4 className="text-sm font-medium text-gray-500 dark:text-gray-400 mb-2" data-id="element-815">
                Quick Actions
              </h4>
              <div className="flex flex-wrap gap-2" data-id="element-816">
                <button onClick={() => {
              setShowViewModal(false);
              handleViewStores(selectedChainMerchant);
            }} className="px-3 py-1 bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-300 rounded-md text-sm" data-id="element-817">
                  View Stores
                </button>
                <button className="px-3 py-1 bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-300 rounded-md text-sm" data-id="element-818">
                  Generate QR Codes
                </button>
                <button className="px-3 py-1 bg-purple-100 text-purple-700 dark:bg-purple-900/30 dark:text-purple-300 rounded-md text-sm" data-id="element-819">
                  View Transactions
                </button>
              </div>
            </div>
          </div>}
      </Modal>

      {/* Add/Edit Chain Merchant Modal */}
      <Modal isOpen={showAddEditModal} onClose={() => setShowAddEditModal(false)} title={isEditing ? 'Edit Chain Merchant' : 'Add Chain Merchant'} size="lg" footer={<>
            <button onClick={() => setShowAddEditModal(false)} className="px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md text-sm font-medium text-gray-700 dark:text-gray-200 bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700" data-id="element-821">
              Cancel
            </button>
            <button onClick={handleSubmitForm} className="px-4 py-2 border border-transparent rounded-md text-sm font-medium text-white bg-blue-600 hover:bg-blue-700" data-id="element-822">
              {isEditing ? 'Update' : 'Add'} Chain Merchant
            </button>
          </>} data-id="element-820">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-823">
          <div className="md:col-span-2" data-id="element-824">
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" data-id="element-825">
              Chain Merchant Name <span className="text-red-500" data-id="element-826">*</span>
            </label>
            <input type="text" name="name" value={formData.name || ''} onChange={handleFormChange} className="w-full rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 py-2 px-3 text-sm" placeholder="Enter chain merchant name" required data-id="element-827" />
          </div>
          <div data-id="element-828">
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" data-id="element-829">
              Business Type <span className="text-red-500" data-id="element-830">*</span>
            </label>
            <select name="businessType" value={formData.businessType || ''} onChange={handleFormChange} className="w-full rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 py-2 px-3 text-sm" required data-id="element-831">
              <option value="" data-id="element-832">Select Business Type</option>
              <option value="Retail" data-id="element-833">Retail</option>
              <option value="Food & Beverage" data-id="element-834">Food & Beverage</option>
              <option value="Technology" data-id="element-835">Technology</option>
              <option value="Home Improvement" data-id="element-836">Home Improvement</option>
              <option value="Hospitality" data-id="element-837">Hospitality</option>
              <option value="Healthcare" data-id="element-838">Healthcare</option>
              <option value="Education" data-id="element-839">Education</option>
              <option value="Entertainment" data-id="element-840">Entertainment</option>
            </select>
          </div>
          <div data-id="element-841">
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" data-id="element-842">
              Tax ID <span className="text-red-500" data-id="element-843">*</span>
            </label>
            <input type="text" name="taxId" value={formData.taxId || ''} onChange={handleFormChange} className="w-full rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 py-2 px-3 text-sm" placeholder="Enter tax ID" required data-id="element-844" />
          </div>
          <div data-id="element-845">
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" data-id="element-846">
              Super Merchant <span className="text-red-500" data-id="element-847">*</span>
            </label>
            <select name="superMerchantId" value={formData.superMerchantId || ''} onChange={handleFormChange} className="w-full rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 py-2 px-3 text-sm" required data-id="element-848">
              <option value="" data-id="element-849">Select Super Merchant</option>
              {superMerchantsOptions.map(sm => <option key={sm.id} value={sm.id} data-id="element-850">
                  {sm.name}
                </option>)}
            </select>
          </div>
          <div data-id="element-851">
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" data-id="element-852">
              Contact Person <span className="text-red-500" data-id="element-853">*</span>
            </label>
            <input type="text" name="contactPerson" value={formData.contactPerson || ''} onChange={handleFormChange} className="w-full rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 py-2 px-3 text-sm" placeholder="Enter contact person name" required data-id="element-854" />
          </div>
          <div data-id="element-855">
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" data-id="element-856">
              Status
            </label>
            <select name="status" value={formData.status || 'active'} onChange={handleFormChange} className="w-full rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 py-2 px-3 text-sm" data-id="element-857">
              <option value="active" data-id="element-858">Active</option>
              <option value="inactive" data-id="element-859">Inactive</option>
              <option value="pending" data-id="element-860">Pending</option>
            </select>
          </div>
          <div data-id="element-861">
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" data-id="element-862">
              Email <span className="text-red-500" data-id="element-863">*</span>
            </label>
            <input type="email" name="email" value={formData.email || ''} onChange={handleFormChange} className="w-full rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 py-2 px-3 text-sm" placeholder="Enter email address" required data-id="element-864" />
          </div>
          <div data-id="element-865">
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" data-id="element-866">
              Phone <span className="text-red-500" data-id="element-867">*</span>
            </label>
            <input type="tel" name="phone" value={formData.phone || ''} onChange={handleFormChange} className="w-full rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 py-2 px-3 text-sm" placeholder="Enter phone number" required data-id="element-868" />
          </div>
        </div>
      </Modal>

      {/* Add Store Modal */}
      <Modal isOpen={showAddStoreModal} onClose={() => setShowAddStoreModal(false)} title="Add Store" size="md" footer={<>
            <button onClick={() => setShowAddStoreModal(false)} className="px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md text-sm font-medium text-gray-700 dark:text-gray-200 bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700" data-id="element-870">
              Cancel
            </button>
            <button onClick={handleSubmitStoreForm} className="px-4 py-2 border border-transparent rounded-md text-sm font-medium text-white bg-blue-600 hover:bg-blue-700" data-id="element-871">
              Add Store
            </button>
          </>} data-id="element-869">
        <div className="space-y-4" data-id="element-872">
          <div data-id="element-873">
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" data-id="element-874">
              Store Name <span className="text-red-500" data-id="element-875">*</span>
            </label>
            <input type="text" name="name" value={storeFormData.name || ''} onChange={handleStoreFormChange} className="w-full rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 py-2 px-3 text-sm" placeholder="Enter store name" required data-id="element-876" />
          </div>
          <div data-id="element-877">
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" data-id="element-878">
              Address <span className="text-red-500" data-id="element-879">*</span>
            </label>
            <textarea name="address" value={storeFormData.address || ''} onChange={handleStoreFormChange} rows={3} className="w-full rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 py-2 px-3 text-sm" placeholder="Enter store address" required data-id="element-880" />
          </div>
          <div data-id="element-881">
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" data-id="element-882">
              Status
            </label>
            <select name="status" value={storeFormData.status || 'active'} onChange={handleStoreFormChange} className="w-full rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 py-2 px-3 text-sm" data-id="element-883">
              <option value="active" data-id="element-884">Active</option>
              <option value="inactive" data-id="element-885">Inactive</option>
              <option value="pending" data-id="element-886">Pending</option>
            </select>
          </div>
          <div className="flex items-start mt-4" data-id="element-887">
            <InfoIcon className="h-5 w-5 text-blue-500 mr-2 flex-shrink-0 mt-0.5" data-id="element-888" />
            <p className="text-sm text-gray-600 dark:text-gray-400" data-id="element-889">
              After adding the store, you can configure terminals, payment
              methods, and transaction limits.
            </p>
          </div>
        </div>
      </Modal>

      {/* Bulk Upload Modal */}
      <Modal isOpen={showBulkUploadModal} onClose={() => setShowBulkUploadModal(false)} title="Bulk Upload Stores" size="md" data-id="element-890">
        <div className="space-y-4" data-id="element-891">
          <p className="text-sm text-gray-600 dark:text-gray-400" data-id="element-892">
            Upload a CSV or Excel file containing multiple stores to add them in
            bulk. Please ensure your file follows the required format.
          </p>
          <div className="border-2 border-dashed border-gray-300 dark:border-gray-600 rounded-md px-6 pt-5 pb-6" data-id="element-893">
            <div className="space-y-2 text-center" data-id="element-894">
              <UploadIcon className="mx-auto h-12 w-12 text-gray-400" data-id="element-895" />
              <div className="flex text-sm text-gray-600 dark:text-gray-400" data-id="element-896">
                <label htmlFor="file-upload" className="relative cursor-pointer rounded-md bg-white dark:bg-gray-800 font-medium text-blue-600 dark:text-blue-400 hover:text-blue-500 dark:hover:text-blue-300 focus-within:outline-none" data-id="element-897">
                  <span data-id="element-898">Upload a file</span>
                  <input id="file-upload" name="file-upload" type="file" className="sr-only" data-id="element-899" />
                </label>
                <p className="pl-1" data-id="element-900">or drag and drop</p>
              </div>
              <p className="text-xs text-gray-500 dark:text-gray-400" data-id="element-901">
                CSV, XLSX up to 10MB
              </p>
            </div>
          </div>
          <div className="bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-md p-3" data-id="element-902">
            <h4 className="text-sm font-medium text-blue-800 dark:text-blue-300 flex items-center" data-id="element-903">
              <InfoIcon className="h-4 w-4 mr-2" data-id="element-904" />
              Template Format
            </h4>
            <p className="mt-1 text-sm text-blue-700 dark:text-blue-400" data-id="element-905">
              Your file should include columns for Store Name, Address, Status,
              and any additional store information.
            </p>
            <div className="mt-2" data-id="element-906">
              <a href="#" className="text-sm font-medium text-blue-600 dark:text-blue-400 hover:underline" data-id="element-907">
                Download Template
              </a>
            </div>
          </div>
          <div className="flex justify-end space-x-3 mt-4" data-id="element-908">
            <button onClick={() => setShowBulkUploadModal(false)} className="px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md text-sm font-medium text-gray-700 dark:text-gray-200 bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700" data-id="element-909">
              Cancel
            </button>
            <button className="px-4 py-2 border border-transparent rounded-md text-sm font-medium text-white bg-blue-600 hover:bg-blue-700" data-id="element-910">
              Upload and Process
            </button>
          </div>
        </div>
      </Modal>

      {/* Delete Confirmation Modal */}
      <Modal isOpen={showDeleteModal} onClose={() => setShowDeleteModal(false)} title="Confirm Deletion" footer={<>
            <button onClick={() => setShowDeleteModal(false)} className="px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md text-sm font-medium text-gray-700 dark:text-gray-200 bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700" data-id="element-912">
              Cancel
            </button>
            <button onClick={confirmDelete} className="px-4 py-2 border border-transparent rounded-md text-sm font-medium text-white bg-red-600 hover:bg-red-700" data-id="element-913">
              Delete
            </button>
          </>} data-id="element-911">
        <div className="space-y-4" data-id="element-914">
          <p className="text-gray-700 dark:text-gray-300" data-id="element-915">
            Are you sure you want to delete the chain merchant "
            {selectedChainMerchant?.name}"? This action cannot be undone.
          </p>
          {selectedChainMerchant && selectedChainMerchant.storeCount > 0 && <div className="bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-200 dark:border-yellow-800 rounded-md p-3 text-sm text-yellow-800 dark:text-yellow-300" data-id="element-916">
              <p className="font-medium" data-id="element-917">
                Warning: This chain merchant has{' '}
                {selectedChainMerchant.storeCount} stores
              </p>
              <p className="mt-1" data-id="element-918">
                Deleting this chain merchant will also delete all associated
                stores and their transaction history.
              </p>
            </div>}
        </div>
      </Modal>
    </div>;
};
export default ChainMerchantSetup;